import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'

import Bio from '../components/Bio/Bio'
import { rhythm, scale } from '../utils/typography'
import Seo from '../components/Seo'
import Nav from '../components/Nav'

class BlogPostTemplate extends React.Component {
  render() {
    const moment = require("moment")
    const now = moment(new Date());
    const post = this.props.data.markdownRemark
    // const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const { previous, next } = this.props.pathContext
    const { data } = this.props
    //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
    const tags = post.frontmatter.tags || []
    const { totalCount } = data.allMarkdownRemark
    const postsCountHeader = `${totalCount} post${totalCount === 1 ? '' : 's'}`
    const config = require('../../content/meta/config')
    const d = {
      title: post.frontmatter.title,
      description: post.frontmatter.title + ' at ' + config.shortSiteTitle,
      image: post.frontmatter.cover.relativePath ? config.siteUrl + '/' + post.frontmatter.cover.relativePath : config.siteImage,
      url: config.siteUrl + post.fields.slug,
      keywords: tags,
      datePublished: "2018-07-01",
      dateUpdated: now.format("YYYY-MM-DD")
    }

    return (
      <div>
        <Seo pageType='post' data={d} />
        <Nav />
        <h1>{post.frontmatter.title}</h1>
        Tagged in {'  '}
        {tags.map((tag, index) => {
          return (
            <span
              style={{
                margin: '0px 12px 0px 0px',
                paddingLeft: '4px',
                //border: '1px solid rebeccapurple',
              }}
              key={index}
              className="tag"
            >
              <Link
                to={`/tags/${tag}`}
                style={{
                  color: 'rebeccapurple',
                  textDecoration: 'none',
                }}
              >
                {tag}
              </Link>{' '}
            </span>
          )
        })}
        <p
          style={{
            ...scale(-1 / 5),
            display: 'block',
            marginBottom: rhythm(1),
            marginTop: rhythm(1),
          }}
        >
          {post.frontmatter.date}
        </p>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
        <Bio articleCount={postsCountHeader} isLast={true} />
        <ul
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: 0,
          }}
        >
          {previous && (
            <li>
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            </li>
          )}

          {next && (
            <li>
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            </li>
          )}
        </ul>
      </div>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    allMarkdownRemark(
      filter: { id: { regex: "//posts//" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount      
    }
    site {
      siteMetadata {
        title
        author
        facebook {
          appId
        }
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      fields{
        slug
      }
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
        cover{
          relativePath
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js